import { useEffect, useState } from "react";

export interface RadioBtnProps {
  checked?: boolean;
  onClickCheck?: () => void;
  color?: string;
}
const RadioBtn: React.FC<RadioBtnProps> = ({
  checked,
  onClickCheck,
  color,
}) => {
  return (
    <>
      {checked ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={onClickCheck && onClickCheck}
          cursor="pointer"
        >
          <rect
            x="7"
            y="7"
            width="10"
            height="10"
            rx="5"
            fill={color || "#B89645"}
            stroke={color || "#B89645"}
            strokeWidth="2"
          />
          <rect
            x="1"
            y="1"
            width="22"
            height="22"
            rx="11"
            stroke={color || "#B89645"}
            strokeWidth="2"
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={onClickCheck && onClickCheck}
          cursor="pointer"
        >
          <rect
            x="1"
            y="1"
            width="22"
            height="22"
            rx="11"
            stroke={color || "#828282"}
            strokeWidth="2"
          />
        </svg>
      )}
    </>
  );
};

export default RadioBtn;
